import { Outlet } from "react-router-dom";
import fsvLogo from "@/images/achieveos-logo.png";
import fsvLogoDark from "@/images/achieveos-logo-dark.png";
import EnvironmentBadge from "@/components/EnvironmentBadge";

export const AuthLayout = () => {
  return (
    <div className="flex justify-center w-full min-h-screen bg-theme-bg-page py-4">
      {/* Environment Badge */}
      <EnvironmentBadge />

      <div className="bg-theme-bg-surface m-4 card max-w-[54.5rem] rounded-lg shadow-lg">
        <div className="flex flex-col items-center w-full min-h-full">
          <img
            src={fsvLogo}
            alt="AchieveOS Logo"
            className="logo-light-mode h-[50px] w-[218px] max-w-full object-contain"
          />
          <img
            src={fsvLogoDark}
            alt="AchieveOS Logo"
            className="logo-dark-mode h-[50px] w-[218px] max-w-full object-contain"
          />
          <div className="flex flex-col mt-4 items-center w-full flex-grow">
            <Outlet />
          </div>

          {/* Footer with navigation links */}
          <footer className="w-full mt-8 pt-6 border-t border-theme-border">
            <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 px-6 pb-4">
              {/* <a
                href="https://forwardshare.co/terms-of-use-and-privacy-policy#terms-of-use"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-theme-text-secondary hover:text-theme-text-link transition-colors"
              >
                Terms & Conditions
              </a>
              <span className="text-theme-text-muted hidden sm:inline">•</span>
              <a
                href="https://forwardshare.co/terms-of-use-and-privacy-policy#privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-theme-text-secondary hover:text-theme-text-link transition-colors"
              >
                Privacy Policy
              </a> */}
              <span className="text-theme-text-muted hidden sm:inline">•</span>
              <a
                href="https://forwardshare.co/contact"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-theme-text-secondary hover:text-theme-text-link transition-colors"
              >
                Contact Us
              </a>
            </div>
            <div className="text-center pb-4">
              <p className="text-xs text-theme-text-muted">
                © {new Date().getFullYear()} Forward Share Ventures. All rights reserved.
              </p>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
